// Copyright (c) 2018 Deere & Company

import ExportToExcel, {getDefaultState} from '../state/export-to-excel';
import actions from '../actions-list';

const pushAvailableColumn = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            availableColumns: {
                $push: [action.column]
            }
        }
    });

const pushExcelLayoutColumn = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            excelLayout: {
                columns: {
                    $push: [action.column]
                }
            }
        }
    });

const removeAvailableColumn = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            availableColumns: {
                $splice: [
                    [action.index, 1]
                ]
            }
        }
    });

const removeExcelLayoutColumn = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            excelLayout: {
                columns: {
                    $splice: [
                        [action.index, 1]
                    ]
                }
            }
        }
    });

const resetLayout = state =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            $set: getDefaultState().excelLayoutModal
        }
    });

const resetSelectedLayout = (state, action) =>
    ExportToExcel.update(state, {
        selectedExcelLayout: {
            [action.listId]: {
                $set: getDefaultState().selectedExcelLayout[action.listId]
            }
        }
    });

const updateExcelLayoutIsDefault = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            excelLayout: {
                isDefault: {
                    $set: action.isDefault
                }
            }
        }
    });

const updateExcelLayoutListId = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            excelLayout: {
                listId: {
                    $set: action.listId
                }
            }
        }
    });

const updateExcelLayoutSortBy = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            excelLayout: {
                sortBy: {
                    $splice: [
                        [0, 1, action.sortBy]
                    ]
                }
            }
        }
    });

const updateAvailableColumns = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            availableColumns: {
                $set: action.availableColumns
            }
        }
    });

const updateAvailableColumnsOrder = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            availableColumns: {
                $splice: [
                    [action.dragIndex, 1],
                    [action.hoverIndex, 0, action.dragCard]
                ]
            }
        }
    });

const updateExcelLayout = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            excelLayout: {
                $set: action.excelLayout
            }
        }
    });

const updateExcelLayoutColumnsOrder = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            excelLayout: {
                columns: {
                    $splice: [
                        [action.dragIndex, 1],
                        [action.hoverIndex, 0, action.dragCard]
                    ]
                }
            }
        }
    });

const updateIsNameValid = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            isNameValid: {
                $set: action.isNameValid
            }
        }
    });

const updateIsNewLayout = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            isNewLayout: {
                $set: action.isNewLayout
            }
        }
    });

const updateLayoutName = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            excelLayout: {
                name: {
                    $set: action.name
                }
            }
        }
    });

const updateModalVisibility = (state, action) =>
    ExportToExcel.update(state, {
        excelLayoutModal: {
            isModalOpen: {
                $set: action.isModalOpen
            }
        }
    });

const updateExcelLayouts = (state, action) =>
    ExportToExcel.update(state, {
        excelLayouts: {
            [action.listId]: {
                $set: action.excelLayouts
            }
        }
    });

const updateSelectedExcelLayout = (state, action) =>
    ExportToExcel.update(state, {
        selectedExcelLayout: {
            [action.listId]: {
                $set: action.selectedExcelLayout
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.PUSH_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMN]: pushAvailableColumn,
        [actions.PUSH_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMN]: pushExcelLayoutColumn,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS]: updateAvailableColumns,
        [actions.REMOVE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMN]: removeAvailableColumn,
        [actions.REMOVE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMN]: removeExcelLayoutColumn,
        [actions.RESET_EXPORT_TO_EXCEL_LAYOUT]: resetLayout,
        [actions.RESET_EXPORT_TO_EXCEL_SELECTED_LAYOUT]: resetSelectedLayout,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_IS_DEFAULT]: updateExcelLayoutIsDefault,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_LIST_ID]: updateExcelLayoutListId,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_SORT_BY]: updateExcelLayoutSortBy,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_SORT_DIRECTION]: updateExcelLayoutSortBy,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS_ORDER]: updateAvailableColumnsOrder,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT]: updateExcelLayout,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMNS_ORDER]: updateExcelLayoutColumnsOrder,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_IS_NAME_VALID]: updateIsNameValid,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_IS_NEW_LAYOUT]: updateIsNewLayout,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_LAYOUT_NAME]: updateLayoutName,
        [actions.UPDATE_EXCEL_LAYOUT_MODAL_VISIBILITY]: updateModalVisibility,
        [actions.UPDATE_EXCEL_LAYOUTS]: updateExcelLayouts,
        [actions.UPDATE_SELECTED_EXCEL_LAYOUT]: updateSelectedExcelLayout
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/shared/reducers/export-to-excel.js